const CHUNK_SIZE = 4;

/** An event that carries a piece of text; the other events of a stream are not touched. */
interface TextEvent {
  type: 'delta';
  text: string;
}

interface Latency {
  /** Between two small pieces of the answer. */
  textDelayMs?: number;
}

const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

const isText = (event: { type: string }): event is TextEvent =>
  event.type === 'delta';

/**
 * Makes the text of a stream arrive in small pieces, as it does from a real model on a slow
 * connection. A whole answer can arrive in a few milliseconds, which hides how the screen grows.
 */
export default async function* withSimulatedLatency<T extends { type: string }>(
  events: AsyncIterable<T>,
  { textDelayMs = 30 }: Latency = {}
): AsyncGenerator<T | TextEvent> {
  for await (const event of events) {
    if (isText(event)) {
      for (let start = 0; start < event.text.length; start += CHUNK_SIZE) {
        await sleep(textDelayMs);
        yield {
          type: 'delta',
          text: event.text.slice(start, start + CHUNK_SIZE),
        };
      }
    } else {
      yield event;
    }
  }
}
